<ng-template #profileChangePasswordModal id="profileChangePwdModal">
  <div [ngClass]="{'modal-content' : isSuccess, 'modal-content-success': !isSuccess}" id="profilePwdModalCon">
    <div _ngcontent-fjy-c198="" class="close" (click)="dismiss()" id="profileChangeClose">
      <img _ngcontent-fjy-c198="" alt="close" class="modal-close-icon">
    </div>
    <div class="modal-body" *ngIf='!openModalPopup' id="modalBody">
      <div class="heading" id="changePwd">
         <span i18n="@@device-password-popup.title.device-password-title">Change {{type}} Password</span> </div>
      <div class="mt-2 mb-3" id="pwdDesc">
        {{passwordsDesc}}
      </div>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-group" id="newPwdFrmGrp">
          <label> <span i18n="@@device-password-popup.password-label.device-password-label">New {{type}} Password</span>
          </label>
          <input class="form-control" ng-maxlength="30" [type]="fieldTextType ? 'text' : 'password'"
            [placeholder]="enterPasswordPlaceHolder" formControlName="password" id="password"
            [ngClass]="{ 'has-error': f.password.touched && f.password.invalid && f.password.errors}" maxlength="30" />
          <em *ngIf="f.password.value" [ngClass]="{
                    'eye-slash': fieldTextType,
                    'eye': !fieldTextType
                  }" (click)="toggleFieldTextType()"></em>
          <em class="error_icon" *ngIf="f.password.touched && f.password.invalid && f.password.errors"></em>
          <div *ngIf="f.password.touched && f.password.invalid" class="formfield_err_msg" id="pwdErrMsgField">
            <div *ngIf="f.password.errors.required" id="pwdLabel">{{passwordLabel}}</div>
            <div *ngIf="f.password.errors.minlength" id="pwdErrMsg">{{passwordErrorMessage}}</div>
            <div *ngIf="f.confirm_password.errors.confirmedValidator" id="pwdMatch">{{passwordMatch}}</div>
          </div>
        </div>
        <div class="form-group" id="confirmPwd">
          <label> <span i18n="@@device-password-popup.confirm-password-label.device-confirm-password-label">Confirm
              {{type}} Password</span> </label>
          <input class="form-control" [type]="fieldTextType2 ? 'text' : 'password'"
            [placeholder]="confirmPasswordPlaceHolder" formControlName="confirm_password" id="confirm_password"
            [ngClass]="{ 
                    'has-error': f.confirm_password.touched && f.confirm_password.invalid && f.confirm_password.errors
                  }" maxlength="30" />
          <em *ngIf="f.confirm_password.value" [ngClass]="{
                    'eye-slash': fieldTextType2,
                    'eye': !fieldTextType2
                  }" (click)="toggleFieldTextType2()"></em>
          <em class="error_icon"
            *ngIf="f.confirm_password.touched && f.confirm_password.invalid && f.confirm_password.errors"></em>
          <div *ngIf="f.confirm_password.touched && f.confirm_password.invalid" class="formfield_err_msg" id="pwdErrMsg">
            <div *ngIf="f.confirm_password.errors.required" id="confirmPwdLabel">
              <span>{{passwordLabel}}</span>
            </div>
            <div *ngIf="f.confirm_password.errors.minlength" id="confirmPwdErrMsg">
              <span>{{passwordErrorMessage}}</span>
            </div>
            <div *ngIf="f.confirm_password.errors.confirmedValidator" id="confirmPwdValidator">
              <span>{{passwordMatch}}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer" *ngIf='!openModalPopup' id="pwdModalFooter">
      <button class="btn btn-outline-primary btn-lg" (click)="dismiss()">
        {{cancel}}
      </button>
      <button class="btn btn-primary btn-lg" (click)="submit()" [disabled]="!form.valid">
        <span i18n="@@device-password-popup.button-label.device-password-change">Change Password</span>
      </button>
    </div>
    <div class="modal-body" *ngIf='openModalPopup' id="pwdModalBody">
      <div class="action_on_pending_user" id="actionOnPendingUsr">
        <span class="success_img"></span>
      </div>
      <div class="action-success-msg" id="successMsg">
        <span>{{successMessage}}</span>
      </div>
      <div class="card_desc" id="cardDesc">
        <span>{{description}}</span>
      </div>
    </div>
  </div>
</ng-template>